import { useEffect, useState } from "react";
import { DomainOptionType, DomainStepView, DomainType } from "../constants";
import {
  useDomainStatusByApiQuery,
  useProgectsDomainByIdQuery,
} from "../graphql/projects.hooks";

export function useDomains({ id }: { id: string }) {
  const { data: domainData, loading: domainDataLoading } =
    useProgectsDomainByIdQuery({
      variables: { domainId: +id },
      fetchPolicy: "network-only",
    });

  const [selectedOption, setSelectedOption] = useState(DomainOptionType.Domain);
  const [isNextStepDisabled, setIsNextStepDisabled] = useState(false);
  const [urlType, setUrlType] = useState<number | null>(null);
  const [isCustomStep, setIsCustomStep] = useState(false);
  const [stepView, setStepView] = useState(DomainStepView.Default);

  const {
    data: domainStatusData,
    loading: domainStatusDataLoading,
    refetch: refetchDomainStatusData,
  } = useDomainStatusByApiQuery({
    variables: { domainId: +id },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const urlType = data?.domainStatusByApi?.urlType;
      setUrlType(urlType);
      if (!urlType) return;
      const urlTypeToOption: Record<DomainType, DomainOptionType> = {
        [DomainType.Subdomain]: DomainOptionType.Subdomain,
        [DomainType.UserDomain]: DomainOptionType.UserDomain,
        [DomainType.UserSubdomain]: DomainOptionType.UserSubdomain,
      };

      const selectedOption = urlTypeToOption[urlType as DomainType];
      if (selectedOption) {
        setSelectedOption(selectedOption);
      }
    },
    onError: () => {
      setUrlType(null);
      setStepView(DomainStepView.Default);
    },
    skip: domainData?.domain.urlType === 0 || !domainData?.domain,
  });

  useEffect(() => {
    setIsNextStepDisabled(
      selectedOption !== DomainOptionType.Domain && !urlType
    );
  }, [selectedOption, urlType]);

  return {
    selectedOption,
    setSelectedOption,
    isNextStepDisabled,
    setIsNextStepDisabled,
    isCustomStep,
    setIsCustomStep,
    stepView,
    setStepView,
    urlType,
    domainStatusData,
    domainStatusDataLoading: domainStatusDataLoading || domainDataLoading,
    refetchDomainStatusData,
  };
}
